if (window.wp && window.wp.ajax)
{

    const { registerBlockType } = window.wp.blocks;

    const {
        RichText,
        InspectorControls,
        ColorPalette,
        MediaUpload,
        InnerBlocks
    } = window.wp.editor;

    const {
        PanelBody,
        IconButton,
        RangeControl,
        TextControl,
        __experimentalNumberControl,
        CheckboxControl 
    } = window.wp.components;

    const cardHtml = import('./offer-template-card');

    registerBlockType('custom-gutenberg/offer', {
        // built-in attributes
        title: 'Offer',
        description: 'Custom Offer',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            title: {
                type: 'string',
                default: '',
            },
            subtitle: {
                type: 'string',
                default: ''
            },
            link: {
                type: 'string',
                default: ''
            },
            cta: {
                type: 'string',
                default: ''
            },

            perPage: {
                type: 'string',
                default: '9'
            },
            pets: {
                type: 'boolean',
                default: false
            },
            tagCategoryId: {
                type: 'string',
                default: ''
            },
            pool: {
                type: 'boolean',
                default: false
            },
            hasDiscout: {
                type: 'boolean',
                default: false
            },
            distanceSea: {
                type: 'number',
                default: ''
            },
            guests: {
                type: 'string',
                default: ''
            },
            heatedPool: {
                type: 'boolean',
                default: false
            },
            hydromassageBathtub: {
                type: 'boolean',
                default: false
            },
            hasDiscount: {
                type: 'boolean',
                default: false
            },
            sauna: {
                type: 'boolean',
                default: false
            },
            
            isSlider: {
                type: 'boolean',
                default: false
            },


        },

        // built-in functions
        edit({ attributes, setAttributes })
        {

            const {
                link,
                title,
                cta,
                subtitle,
                perPage,
                pets,
                tagCategoryId,
                pool,
                hasDiscount,
                distanceSea,
                guests,
                heatedPool,
                hydromassageBathtub,
                sauna,

                isSlider
            } = attributes;

            const MY_TEMPLATE = [
                [ 'custom-gutenberg/offer-card', {} ],
            ];

            return ([
                <InspectorControls style={{ marginBottom: '40px' }}>
                    <PanelBody title={'Section'}>
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Is slider"
                            checked={ isSlider }
                            onChange={ isSlider => setAttributes({ isSlider })}
                        />
                        <br></br>
                        <p><strong>Title</strong></p>
                        <TextControl value={title} onChange={title => setAttributes({ title })}></TextControl>
                        <p><strong>Subtitle</strong></p>
                        <TextControl value={subtitle} onChange={subtitle => setAttributes({ subtitle })}></TextControl>
                        <p><strong>Cta text</strong></p>
                        <TextControl value={cta} onChange={cta => setAttributes({ cta })}></TextControl>
                        <p><strong>Enter url: (ex: /en/villas)</strong></p>
                        <TextControl value={link} onChange={link => setAttributes({ link })}></TextControl>
                    </PanelBody>

                    <PanelBody title={'Parameters'}>
                        <p><strong>Per page</strong></p>
                        <TextControl value={perPage} onChange={perPage => setAttributes({ perPage })}></TextControl>
                        <br></br>
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Pets"
                            checked={ pets }
                            onChange={ pets => setAttributes({ pets })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Pool"
                            checked={ pool }
                            onChange={ pool => setAttributes({ pool })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Special offer"
                            checked={ hasDiscount }
                            onChange={ hasDiscount => setAttributes({ hasDiscount })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Heated pool"
                            checked={ heatedPool }
                            onChange={ heatedPool => setAttributes({ heatedPool })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Hydromassage bathtub"
                            checked={ hydromassageBathtub }
                            onChange={ hydromassageBathtub => setAttributes({ hydromassageBathtub })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Sauna"
                            checked={ sauna }
                            onChange={ sauna => setAttributes({ sauna })}
                        />

                        <p><strong>Guests</strong></p>
                        <TextControl value={guests} onChange={guests => setAttributes({ guests })}></TextControl>

                        <p><strong>Tag Category ID</strong></p>
                        <TextControl label="ex. 123 or 123,765,5675" value={tagCategoryId} onChange={tagCategoryId => setAttributes({ tagCategoryId })}></TextControl>

                        <p><strong>Distance sea</strong></p>
                        <__experimentalNumberControl value={distanceSea} onChange={distanceSea => setAttributes({ distanceSea })}></__experimentalNumberControl>

                    </PanelBody>

                </InspectorControls>
                ,
                <div class="" style={{ bottom: 0, left: 0, right: 0 }} >
                    <div class="row">
                        <div class="col-lg mb-0">
                            <RichText
                                key="editable"
                                tagName="h3"
                                class="text-dark h1"
                                placeholder="Our best offer"
                                value={title}
                                onChange={title => setAttributes({ title })}
                            />
                            <RichText
                                key="editable"
                                tagName="p"
                                class="lead mb-0"
                                placeholder="Experience summer with latest special offer realeses"
                                value={subtitle}
                                onChange={subtitle => setAttributes({ subtitle })}
                            />
                        </div>
                        <div class="col-lg-auto mt-lg-0">
                            <button class="btn btn-primary">
                                <RichText
                                    key="editable"
                                    tagName="span"
                                    class=""
                                    placeholder="Show all offers"
                                    value={cta}
                                    onChange={cta => setAttributes({ cta })}
                                />
                                <i class="las la-arrow-right">
                                </i>
                            </button>

                        </div>
                            <InnerBlocks template={ MY_TEMPLATE } />
                    </div>

                </div>
            ]
            );
        },

        save({ attributes })
        {

            let {
                link,
                subtitle,
                cta,
                title,

                perPage,
                pets,
                tagCategoryId,
                pool,
                hasDiscount,
                distanceSea,
                guests,
                heatedPool,
                hydromassageBathtub,
                sauna,

                isSlider
            } = attributes;
            let hasRegularDiscount = null;
            if (pool) pool = 1;
            if (pets) pets = 1;
            if (hasDiscount) hasDiscount = hasRegularDiscount = 1;
            if (heatedPool) heatedPool = 1;
            if (hydromassageBathtub) hydromassageBathtub = 1;
            if (sauna) sauna = 1;
            if (isSlider) isSlider = 1;

            let params = {
                perPage,
                pets,
                tagCategoryId,
                pool,
                hasDiscount,
                hasRegularDiscount,
                distanceSea,
                guests,
                heatedPool,
                hydromassageBathtub,
                sauna,
                isSlider
            };

            $.map(params, (value, key) => !value && (delete params[key]));


            let scParams = window.jQuery.extend({}, params);
            if (scParams.guests) 
            {
                scParams.persons = scParams.guests;
                delete scParams.guests;
            }

            if (params.guests) params.guests = params.guests + ',0,0';

            scParams = window.jQuery.param(scParams).replaceAll('&', ' ') + ' ';

            if (params.isSlider) delete params.isSlider;
            if (params.hasRegularDiscount) delete params.hasRegularDiscount;
            if (params.perPage) delete params.perPage;

            if (! link.includes('#') ) link = link + '#' + window.jQuery.param(params);
            

            let lang = window.jQuery('#icl_post_language') ? window.jQuery('#icl_post_language').find(":selected").val() : 'en';

            return (
                <div className="row mb-lg-4 mb-5">
                    <div className="col-lg mb-lg-4 mb-0">
                        <h3 className="text-dark h1">
                            {title}
                        </h3>
                        <p className="lead mb-0">
                            {subtitle}
                        </p>

                    </div>
                    <div className={ "col-lg-auto mt-2 mt-lg-0 " + (isSlider ? 'mb-lg-0 mb-3' : 'mb-n2') }>
                       <a href={link}>
                            <button className="btn btn-primary">
                                {cta}
                                <i className="las la-arrow-right"></i>
                            </button>
                       </a>

                    </div>
                    
                    [mars_object_list {scParams}template=filter_landing_page language="{lang}"]

                    { ! isSlider && (
                        <div className="col-lg-auto d-lg-none mt-4 mt-lg-0 ">
                            <a href={link}>
                                    <button className="btn btn-primary">
                                        {cta}
                                        <i className="las la-arrow-right"></i>
                                    </button>
                            </a>

                            </div>
                    )}
                    
                </div>
            );
        },
    });
}